import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getCountries } from "./actions";

export const countryEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = countryEntityAdapter.getInitialState({
  count: 0,
});

export const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCountries.fulfilled, (state, action) => {
      if (action.payload?.success) {
        countryEntityAdapter.setAll(state, action?.payload?.countries);
      }
    });
  },
});

export default countrySlice.reducer;
